import { MediaObject } from "../../types/Entities/MediaObject/MediaObject";
import Typography from "@mui/material/Typography";
import moment from "moment";
import React from "react";
import { API_HOST, API_PATH } from "../../config/_entrypoint";
import CardActionArea from "@mui/material/CardActionArea";
import DownloadIcon from "@mui/icons-material/Download";
import { Grid } from "@mui/material";

type MediaObjectRowProps = {
  mediaObject: MediaObject;
};

const MediaObjectRow = ({ mediaObject }: MediaObjectRowProps) => {
  const downloadLink = API_HOST + API_PATH + "/download/" + mediaObject.id + "?token=" + localStorage.getItem("token");

  return (
    <CardActionArea component={"a"} href={downloadLink} sx={{ padding: "1rem" }}>
      <Grid container justifyContent={"space-between"}>
        <Grid item xs={10} sx={{ overflowWrap: "break-word" }}>
          <Typography variant={"h6"}>{mediaObject.description}</Typography>
          <Typography color={"text.secondary"}>{moment(mediaObject.created).format("D. MMMM YYYY")}</Typography>
        </Grid>
        <Grid item>
          <DownloadIcon color={"primary"} sx={{ fontSize: 40 }} />
        </Grid>
      </Grid>
    </CardActionArea>
  );
};

export default MediaObjectRow;
